"use strict";

var _regeneratorRuntime = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _asyncToGenerator = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Constraint = void 0;

var Matter = _interopRequireWildcard(require("matter-js"));

var _World = require("./World");

var _hooks = require("../hooks");

var _react = require("react");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Constraint = function Constraint(props) {
  var world = (0, _World.useWorld)();
  (0, _hooks.useCloseableAsync)(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(closeRef) {
      var options, tasks, constraint;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = {};
              tasks = Object.entries(props).map(
              /*#__PURE__*/
              function () {
                var _ref3 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee(_ref2) {
                  var _ref4, key, promise;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _ref4 = _slicedToArray(_ref2, 2), key = _ref4[0], promise = _ref4[1];

                          if (!(promise == null)) {
                            _context.next = 3;
                            break;
                          }

                          return _context.abrupt("return");

                        case 3:
                          _context.next = 5;
                          return promise;

                        case 5:
                          options[key] = _context.sent;

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());
              _context2.next = 4;
              return Promise.all(tasks);

            case 4:
              constraint = Matter.Constraint.create(options);
              closeRef.current || Matter.World.add(world, constraint);
              return _context2.abrupt("return", constraint);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), function (constraint) {
    return Matter.World.remove(world, constraint);
  });
  return null;
};

exports.Constraint = Constraint;

Constraint.useRefs = function (keys) {
  var promiseRefs = (0, _react.useMemo)(function () {
    var newPromiseRef = function newPromiseRef() {
      var value = null;
      var setValue;
      var promise = new Promise(function (resolve) {
        return setValue = resolve;
      });
      return {
        set current(instance) {
          value = instance;
          instance == null || setValue(instance);
        },

        get current() {
          return value;
        },

        then: promise.then.bind(promise)
      };
    };

    return keys.reduce(function (acc, key) {
      acc[key] = newPromiseRef(); // eslint-disable-line @typescript-eslint/no-explicit-any

      return acc;
    }, {});
  }, []);
  return promiseRefs;
};